import { h, Component } from 'preact';
import pure from 'utils/pure';
import Store from 'store/store';
import { Link } from 'components/core/link/link.js';
import * as actions from 'store/actions';
import s from 'components/pages/showtimes/oneSheet.sss';
import { VerticalStory } from 'pages/showtimes_features.js';
import OneSheetVideo from 'components/shared/oneSheetVideo/oneSheetVideo';
import PreloadThumb from 'components/shared/preloadThumb/preloadThumb';
import { accessNested, sortObjectByOrder, condClass, joinClasses, getStylingImagePath } from 'utils/utils';
import { useDynamicAssetFolder, IMAGE_REGION_ROOT_DYNAMIC } from 'utils/assets';
import { ThreeDImage } from 'pages/showtimes_features.js';

export default @pure class OneSheet extends Component {
	constructor(props) {
		super(props);
		this.forceClose = this.toggleOpen.bind(this, false);
		this.forceOpen = this.toggleOpen.bind(this, true);
		this.toggleOpen = this.toggleOpen.bind(this);
		// Open for non-js
		this.state.open = typeof window === 'undefined';
		this.state.firstTime = false;
		this.state.playing = true;
		this.fullLoop = !!accessNested(props, 'pageData.mobileFullLoop');
	}


	/**
	 * Lifecycle
	 */

	componentDidMount() {
		if (this.props.hideable) {
			this.setState({ firstTime: true });
		}
	}

	componentWillUnmount() {
		Store.emit(actions.HEADER_HIDDEN, false);
	}

	getFilename() {
		let imageRegion = IMAGE_REGION_ROOT_DYNAMIC;
		let pageData = this.props.pageData;
		let oneSheet;

		if (pageData.oneSheetImage) {
			oneSheet = pageData.oneSheetImage;
		} else if (pageData.onesheetName) {
			oneSheet = `${imageRegion}/${pageData.onesheetName}`;
		} else {
			oneSheet = getStylingImagePath(this.props.appData, 'onesheet', `${imageRegion}/onesheet.jpg`);
		}

		return useDynamicAssetFolder(oneSheet);
	}

	/**
	 * Interaction Callbacks
	 */

	/**
	 * Toggle the visible onesheet
	 */
	toggleOpen(state) {
		let newState = typeof state === 'boolean' ? state : !this.state.open;
		if (newState === this.state.open) {
			return;
		}
		this.clientToggled = true;
		this.setState({
			open: newState,
			playing: newState
		});
		let verticalStoryVid = accessNested(this, '$verticalStory.$item0.$video');
		if (newState && verticalStoryVid) {
			// Execute the play() now to make sure we are in a user action handler and browser accept to play videos
			verticalStoryVid.play();
		}
		let headerHidden = newState && Store.get().header.sideNavActive;
		Store.emit(actions.HEADER_HIDDEN, headerHidden);
		let props = this.props;
		let features = props.appData.options;
		let isDesktop = props.client.deviceSize === 'desktop';
		if (features.showtimesVerticalStory && !features.disableShowtimesVerticalStoryMobile && !isDesktop) {
			this.props.toggleVerticalStory(newState);
		}
		clearTimeout(this.toggleHeightTimeout);
		let element = newState ? this.$onesheet : this.$title;
		let height = element && element.clientHeight;
		if (height && this.base) {
			this.base.style.transition = 'none';
			this.base.style.height = this.base.clientHeight + 'px';
			// force reflow
			this.base.clientHeight;
			this.base.style.transition = '';
			this.base.style.height = height + 'px';
			// Ideally would detect animationend
			this.toggleHeightTimeout = setTimeout(() => {
				if (this.base) {
					this.base.style.height = '';
				}
			}, 1100);
		}
	}

	/**
	 * Render
	 */


	render(props, state) {
		const {
			appData,
			hideable,
			client,
			sideNavActive,
			pageData,
			iosFixedFix,
			verticalFullView,
		} = props;

		const {
			oneSheetVideo,
		} = pageData;

		const { open, playing } = state;
		// TODO: change this
		const imageRegion = appData.urls.roots.imageRegion;
		let pages = appData.pages;
		let oneSheetPage = pageData.oneSheetPage || 'videos';
		let pageId = pages[oneSheetPage] && oneSheetPage;
		let redirectTarget;
		let tracking = 'onesheet_link';
		if (pageData.oneSheetLink) {
			redirectTarget = pageData.oneSheetLink;
			pageId = undefined;
		}
		if (pageData.oneSheetTracking) {
			tracking = pageData.oneSheetTracking;
		}

		let { deviceSize } = client;

		let containerStyle = {};
		if (iosFixedFix) {
			containerStyle.position = 'absolute';
			containerStyle.marginTop = iosFixedFix + 'px';
		}

		let isDesktop = deviceSize === 'desktop';
		let vsItems = pageData && pageData.verticalStory;
		/**
		 * VS is replaced with OneSheetVideo
		 * Soon to be deleted completely from the oneSheet page
		 */
		const useVS = vsItems
			&& appData.options.showtimesVerticalStory
			&& !pageData.disableVerticalStory
			&& !(isDesktop && oneSheetVideo);

		if (isDesktop && !this.props.hideable && useVS) {
			return (
				<div
					class={
						!verticalFullView
							? s.container
							: s.mobileVerticalStoryContainer
					}
					style={containerStyle}
				>
					<VerticalStory
						key="verticalStory"
						class={joinClasses(verticalFullView && s.overlay)}
						playing
						regionRoot={imageRegion}
						mobileView={verticalFullView}
						closeCallback={verticalFullView && this.props.toggleVerticalStory.bind(this, false)}
						insideScroll={!verticalFullView}
						baseUrl={`${appData.urls.roots.media}/vertical-story/${appData.meta.region.slug}`}
						verticalStory={sortObjectByOrder(vsItems)}
						options={pageData.verticalStoryOptions}
						appData={appData}
					/>
				</div>
			);
		}

		const onesheetAltText = accessNested(appData, 'copy.$ONESHEET_DESCRIPTION') || 'Poster for ' + accessNested(appData, 'copy.$TITLE', 'the movie');
		const titleShortAltText = (pageData && pageData.titleShortNameAlt) || accessNested(appData, 'copy.$TITLE_SHORT_NAME_ALT') || onesheetAltText;

		if (isDesktop && oneSheetVideo) {
			return (
				<div
					class={!verticalFullView ? s.container : s.mobileVerticalStoryContainer}
					style={containerStyle}
				>
					<OneSheetVideo
						class={joinClasses(verticalFullView && s.overlay)}
						playing
						options={oneSheetVideo}
					/>
				</div>
			);
		}

		let titleClass = pageData.forceFullHeader ? s.fullHeaderTitle : s.title;
		let show;

		if (!pageData.depthMap) {
			show = <img ref={e => (this.$onesheet = e)} class={s.onesheet} src={this.getFilename()} alt={onesheetAltText} />;
		} else {
			show = <ThreeDImage src={this.getFilename()} depthMap={pageData.depthMap} client={client} parentComp="onesheet" />;
		}

		if (isDesktop) {
			let content = (
				<div
					class={joinClasses(s.container, sideNavActive && s.full, this.props.class)}
					onClick={hideable ? this.toggleOpen : null}
					style={containerStyle}
					data-overlay="oneSheet"
				>
					{show}
				</div>
			);
			let showbarebones = false;
			if (typeof window !== 'undefined') {
				showbarebones = window.showbarebones !== undefined ? window.showbarebones : location.search.indexOf('showbarebones') !== -1;
			}
			let disableOnesheetLink = pageData.disableOnesheetLink || showbarebones;
			if (!disableOnesheetLink && (pageId || redirectTarget)) {
				content = (
					<Link
						pageId={pageId}
						target={!pageId ? '_blank' : '_self'}
						href={redirectTarget}
						trackId={tracking}
						tabindex="-1"
					>
						{content}
					</Link>
				);
			}
			return content;
		} else {
			// NOT DESKTOP

			// changed so that hamburger is triggered for tablet or desktop
			let isTabletHamburger = sideNavActive && client.deviceSize == 'tablet';
			let titleClasses = titleClass + condClass(isTabletHamburger, s.tabletHamburger);
			let titleShortSrcDefault = useDynamicAssetFolder(IMAGE_REGION_ROOT_DYNAMIC + '/' + accessNested(pageData, 'titleShortName', 'title-short-bare.jpg'));
			let titleShortSrc = getStylingImagePath(appData, 'title-short-bare', titleShortSrcDefault);

			// We are switching to jpgs for smaller filesizes but need this fallback for when the load fails
			const titleShortFallback = useDynamicAssetFolder(`${IMAGE_REGION_ROOT_DYNAMIC}/title-short-bare.png`);

			const vsOptions =
				(pageData.verticalStory && pageData.verticalStory.options) ||
				pageData.verticalStoryOptions;
			const disableOnMobile = vsOptions ? vsOptions.disableOnMobile : false;
			if (
				appData.options.showtimesVerticalStory &&
				!appData.options.disableShowtimesVerticalStoryMobile &&
				!appData.options.disableShowtimesVerticalStoryGifHeader
			) {
				titleShortSrc = useDynamicAssetFolder(IMAGE_REGION_ROOT_DYNAMIC + '/vertical_story_cta.gif');
			}

			let toggleable = !accessNested(pageData, 'disableOnesheetToggle') && hideable;

			let content;
			if (useVS && !disableOnMobile) {
				// closeCallback={verticalFullView ? this.props.toggleVerticalStory.bind(this, false) : null}
				content = (
					<VerticalStory
						key="verticalStory"
						class={s.verticalStory}
						visible={open}
						playing={playing}
						regionRoot={imageRegion}
						mobileView={verticalFullView}
						closeCallback={e => {
							e.stopPropagation();
							this.forceClose();
						}}
						onVideoEnded={this.fullLoop && !this.clientToggled && this.forceClose}
						loop={!this.fullLoop || this.clientToggled}
						insideScroll={!verticalFullView}
						baseUrl={
							appData.urls.roots.media +
							'/vertical-story/' +
							appData.meta.region.slug
						}
						verticalStory={sortObjectByOrder(vsItems)}
						options={vsOptions}
						appData={appData}
						noClickToggle={toggleable}
						ref={e => this.$verticalStory = e}
					/>
				);
			} else {
				content = (
					<img
						ref={e => (this.$onesheet = e)}
						class={s.onesheet}
						src={this.getFilename()}
						alt={onesheetAltText}
					/>
				);
			}

			// let className = (open ? s.container : s.hidden) + condClass(useVS, s.withVerticalStory) + condClass(this.props.class);
			let className = joinClasses({
				s, container: true,
				hidden: !open,
				withVerticalStory: useVS,
				noToggle: !toggleable
			}, props.class);
			return (
				<div
					class={className}
					onClick={toggleable ? this.toggleOpen : null}
					data-overlay="oneSheet"
				>
					<div class={titleClasses} key="title" ref={e => e && (this.$title = e)}>
						<span class={s.titleCopy}>{appData.copy.$TITLE}</span>
						<PreloadThumb
							containerClass={s.onesheetSmallContainer}
							class={s.onesheetSmall}
							src={titleShortSrc}
							fallbackSrc={titleShortFallback}
							alt={titleShortAltText}
						/>
					</div>
					{content}
				</div>
			);
		}
	}
}
